import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-oauth-error',
  imports: [],
  templateUrl: './oauth-error.component.html',
  styleUrl: './oauth-error.component.css'
})
export class OauthErrorComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    const video = document.querySelector('.home-video') as HTMLVideoElement;
    if (video) {
      video.muted = true;
      setTimeout(() => {
        video.play().catch((err) => console.warn('Autoplay failed:', err));
      }, 50);
    }
  }
}
